"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13 4c-.24 0-.46.1-.63.24l-.01-.01-6 5 .01.01c-.22.19-.37.45-.37.76s.15.57.37.76l-.01.01 6 5 .01-.01c.17.14.39.24.63.24.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"];
//# sourceMappingURL=caret-left.js.map